const swiperContainer = document.querySelector(".swiper-p-story");
const slideCount = swiperContainer
  ? swiperContainer.querySelectorAll(".swiper-slide").length
  : 0;

function shouldEnableSwiper() {
  const isDesktop = window.innerWidth >= 768;
  // On desktop, only enable if more than 4 items (up to 4 render as a
  // static grid); on mobile/tablet always enable
  return !isDesktop || slideCount > 4;
}

let swiperProductStory = null;

function initSwiper() {
  if (shouldEnableSwiper() && !swiperProductStory) {
    swiperProductStory = new Swiper(".swiper-p-story", {
      // Optional parameters
      loop: true,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 16,

      breakpoints: {
        768: {
          slidesPerView: 4,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
      },

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
    });
  } else if (!shouldEnableSwiper() && swiperProductStory) {
    swiperProductStory.destroy(true, true);
    swiperProductStory = null;
  }
}

// Initialize on load
initSwiper();

// Re-check on resize
window.addEventListener("resize", initSwiper);
